<template>
	<div class="dashboard">
		<AppHeader></AppHeader>

		<!-- Main Content -->
		<div class="page-wrapper">
			<div class="container-fluid">

				<!-- Title -->
				<div class="row heading-bg">
					<div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
						<h5 class="txt-dark dashboardTitle">Dashboard</h5>
					</div>
				</div>
				<!-- /Title -->
				<div class="row mb-20">
					<div class="col-xs-12 col-lg-2 datePicker">
						<Datepicker inputClass="form-control" v-model="date"></Datepicker>
						<!-- <p style="font-size:12px;">Date</p>
						<datetime v-model="date" input-id="startDate">
							<template slot="button-cancel">
								<fa :icon="['far', 'times']"></fa>
								Cancel
							</template>
							<template slot="button-confirm">
								<fa :icon="['fas', 'check-circle']"></fa>
								Confirm
							</template>
						</datetime> -->
					</div>
				</div>
				<div class="col-lg-4 col-md-4 col-sm-4 col-xs-12" v-if="food_data">
					<div class="top-panels panel panel-default card-view">
						<div class="panel-heading">
							<div class="pull-left">
								<h4 class="panel-title txt-light">Remaining Calories</h4>
							</div>
							<div class="clearfix"></div>
						</div>
						<div class="panel-wrapper collapse in">
							<div style="padding-top:30px !important;" class="panel-body sm-data-box-1">
								<span class="uppercase-font weight-500 font-14 block text-center txt-dark"></span>
								<div class="cus-sat-stat weight-500 txt-success text-center mt-5">
									<span class="counter-anim">{{food_data.calories_statistics.calories_remaining}}</span>
								</div>
								<div></div>
								<div class="progress-anim mt-20">
									<div class="progress">
										<div class="progress-bar progress-bar-success wow animated progress-animated" :style="'width:' + food_data.calories_statistics.percentage_consumed + '%;'"
										        role="progressbar" :aria-valuenow="food_data.calories_statistics.percentage_consumed" aria-valuemin="0" aria-valuemax="100"></div>
									</div>
								</div>
                        <div class="row">
                           <div class="col-md-12">
                              <ul class="flex-stat mt-5">
                                 <li class="col-md-6">
                                    <span class="block">Goal</span>
                                    <span class="block txt-dark weight-500 font-15">{{food_data.calories_statistics.calories_goal}}</span>
                                 </li>
                                 <li class="col-md-6">
                                    <span class="block">Food</span>
                                    <span class="block txt-dark weight-500 font-15">{{food_data.calories_statistics.calories_consumed}}</span>
                                 </li>
                              </ul>
                           </div>
                        </div>
                        <div class="row">
                           <div class="col-md-12">
                              <ul class="flex-stat mt-30">
                                 <li class="col-md-12">
                                    <span class="block">Calories Burnt</span>
                                    <span class="block txt-dark weight-500 font-15">{{food_data.calories_statistics.calories_burnt}}</span>
                                 </li>
                              </ul>
                           </div>
                        </div>
								<div class="row">
									<div class="col-md-12" style="margin-top:20px;">
										<div class="col-md-6 text-center">
											<router-link to="/food-tracker">
												<button class="btn btn-nutri-orange btn-sm" style="min-width:150px;">Track Food</button>
											</router-link>
										</div>
										<div class="col-md-6 text-center">
											<router-link to="/exercise">
												<button class="btn btn-nutri-orange btn-sm" style="min-width:150px;">Log Exercise</button>
											</router-link>
										</div>
									</div>
								</div>
							</div> 
						</div>
					</div>
					<div style="height:600px !important;overflow-x:auto;" class="panel panel-default card-view panel-refresh" v-show="Object.keys(nutrition_data).length != 0">
						<div class="refresh-container">
							<div class="la-anim-1"></div>
						</div>
						<div class="panel-heading">
							<div class="pull-left">
								<h4 class="panel-title txt-light">Nutritional Information</h4>
							</div>
							<div class="clearfix"></div>
						</div>
						<div class="panel-wrapper collapse in">
							<div class="panel-body">
								<h5 class="text-center mg-b-30">Macro Nutrients</h5>
								<pie-chart :data="nutrition_data" :colors="$store.getters.user.nutrition_chart_colours" legend="bottom"></pie-chart>
							</div>
							<div class="panel-body">
								<div v-for="(item, index) in food_data.nutrient_totals" v-bind:key="index">
									<span class="pull-left inline-block capitalize-font txt-dark">
										{{index.replace(/_/g, ' ')}}
									</span>
									<span v-if="index == 'energy_kj'" class="pull-right text-right">{{(item / 4.184).toFixed(0)}} {{$store.getters.user.recommended_intake_units[index]}}
										<!-- <span class="small" style="font-size:10px;" v-if="!isNaN(item / $store.getters.user.recommended_intake[index] * 100)">({{(item / $store.getters.user.recommended_intake[index] * 100).toFixed(0)}}%)</span> -->
									</span>
									<span v-else class="pull-right text-right">{{item.toFixed(0)}} {{$store.getters.user.recommended_intake_units[index]}}
										<!-- <span class="small" style="font-size:10px;" v-if="!isNaN(item / $store.getters.user.recommended_intake[index] * 100)">({{(item / $store.getters.user.recommended_intake[index] * 100).toFixed(0)}}%)</span> -->
									</span>
									<div class="clearfix"></div>
									<hr class="light-grey-hr row mt-10 mb-10">
								</div>
							</div>
							<div class="text-center">
								<router-link v-if="!$store.getters.user.vip_user" to="/profile/upgrade" class="btn btn-warning full-width mb-30">
									<span>Show More nutritional Data (Go VIP)</span>
								</router-link>
							</div>
							
						</div>
					</div>
					<div style="height:600px !important;" class="panel panel-default card-view panel-refresh" v-show="Object.keys(nutrition_data).length == 0">
						<div class="refresh-container">
							<div class="la-anim-1"></div>
						</div>
						<div class="panel-heading">
							<div class="pull-left">
								<h4 class="panel-title txt-light">Nutritional Information</h4>
							</div>
							<div class="clearfix"></div>
						</div>
						<div class="panel-wrapper collapse in text-center" style="padding:30px;">
							<small class="">
								No Nutritional Information to show for this day.							
							</small>
							<router-link to="/food-tracker">
								<button class="btn btn-default btn-sm mt-30" style="min-width:150px;">Add Food</button>
							</router-link>
						</div>
					</div>
				</div>

				<div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
					<div class="top-panels panel panel-default card-view panel-refresh">
						<div class="refresh-container">
							<div class="la-anim-1"></div>
						</div>
						<div class="panel-heading">
							<div class="pull-left">
								<h6 class="panel-title txt-light">My Weight Progression</h6>
							</div>
							<div class="pull-right">
								<!-- <a href="#" class="pull-left inline-block mr-15" @click="showWeightWidget = !showWeightWidget; showWeightChart = !showWeightChart">
									<i class="zmdi zmdi-eye"></i>
								</a> -->

								<router-link to="/weight-tracker?tracking=1" class="pull-left inline-block">
									<i class="txt-light zmdi zmdi-plus"></i>
								</router-link>
							</div>
							<div class="clearfix"></div>
						</div>
						<div id="collapse_1" class="panel-wrapper collapse in">
							<div class="panel-body">
								<WeightStatusWidget :date="date" v-show="showWeightWidget" class="animated fadeIn"></WeightStatusWidget>
								<!-- <WeightProgressChart v-show="showWeightChart" class="animated fadeIn"></WeightProgressChart> -->
							</div>
						</div>
					</div>

					<div style="height:600px !important;" class="panel panel-default card-view panel-refresh">
						<div class="refresh-container">
							<div class="la-anim-1"></div>
						</div>
						<div class="panel-heading">
							<div class="pull-left">
								<h6 class="panel-title txt-light">My Weight Progression Chart</h6>
							</div>
							<!-- <div class="pull-right">
								<a href="#" class="pull-left inline-block mr-15" @click="showWeightWidget = !showWeightWidget; showWeightChart = !showWeightChart">
									<i class="zmdi zmdi-eye"></i>
								</a>
								<router-link to="/weight-tracker?tracking=1" class="pull-left inline-block">
									<i class="zmdi zmdi-plus"></i>
								</router-link>
							</div> -->
							<div class="clearfix"></div>
						</div>
						<div style="padding-top:20px;" id="collapse_1" class="panel-wrapper collapse in">
							<WeightProgressChart style="height:500px;" class="animated fadeIn"></WeightProgressChart>
						</div>
					</div>
				</div>

				<div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
					<WaterTracker :show="false" :date="date" :key="waterTrackerKey"></WaterTracker>
					<div>
						<div style="height:600px !important;" class="panel panel-default card-view panel-refresh">
							<div class="refresh-container">
								<div class="la-anim-1"></div>
							</div>
							<div class="panel-heading">
								<div class="pull-left">
									<h6 class="panel-title txt-light">Latest Recipes</h6>
								</div>
								<div class="clearfix"></div>
							</div>
							<div id="collapse_1" class="panel-wrapper collapse in" style="margin-left:-15px;margin-right:-15px;">
								<carousel :perPage="1" paginationActiveColor="#7EC347" paginationColor="#9EC2E2">
									<slide style="max-height:536px; overflow:auto;" v-for="(item, index) in recipes" v-bind:key="index">
										<div>
											<div style="width:100%; height:400px; background-size:cover; background-position:center;" :style="{'background-image': 'url(' + item.photo_url + ')'}">
											</div>
											<div class="slide-title">
												<h4 data-toggle="modal" data-target="#recipeDetailsModal" @click="chosenRecipe = item" style="cursor:pointer">{{item.name}}</h4>
											</div>
										</div>
									</slide>
								</carousel>
							</div>
						</div>
					</div>
				</div>

				<div id="recipeDetailsModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
					<div v-if="chosenRecipe" class="modal-dialog">
						<div class="modal-content">
							<div style="width:100%; height:200px; background-size:cover; background-position:center" :style="{'background-image': 'url(' + chosenRecipe.photo_url + ')'}">
							</div>
							<div class="modal-body">
								<div class="modal-header-icon">
									<h4>{{chosenRecipe.name}}</h4>
								</div>
								<div class="col-md-12 mt-20 mb-30">
										<div class="col-md-4 text-center">
												<h6>Prep time</h6>
												<p>{{chosenRecipe.preparation_time}}</p>
										</div>
										<div class="col-md-4 text-center">
												<h6>Cooking time</h6>
												<p>{{chosenRecipe.cooking_time}}</p>
										</div>
										<div class="col-md-4 text-center">
												<h6>Serves</h6>
												<p>{{chosenRecipe.servings}}</p>
										</div>
								</div>
								<div class="col-md-12">
										<h6>Ingredients</h6>
										<ul>
												<li v-for="(ingredient, index) in chosenRecipe.ingredients" :key="index">{{ingredient.specified_qty}} {{ingredient.measurements_data[ingredient.specified_measurement].measurement_name}} of {{ingredient.html_name}}</li>
										</ul>
								</div>
								<div class="col-md-12 mt-30">
										<h6>Instructions</h6>
										<div v-html="chosenRecipe.instruction_steps">
										</div>
								</div>
								<!-- <div class="col-md-12 mt-30">
									<h6>Nutrients per Serving</h6>
									<NutritionalTrafficLight 
										v-if="chosenRecipe" 
										:calories="chosenRecipe.nutrients_per_serving[1] != null ? chosenRecipe.nutrients_per_serving[1].per_serving : 0" 
										:totalFat="chosenRecipe.nutrients_per_serving[4] != null ? chosenRecipe.nutrients_per_serving[4].per_serving : 0" 
										:saturatedFat="chosenRecipe.nutrients_per_serving[5] != null ? chosenRecipe.nutrients_per_serving[5].per_serving : 0"
										:sugars="chosenRecipe.nutrients_per_serving[11] != null ? chosenRecipe.nutrients_per_serving[11].per_serving : 0" 
										:sodium="chosenRecipe.nutrients_per_serving[12] != null ? chosenRecipe.nutrients_per_serving[12].per_serving : 0" 
										:energyKj="chosenRecipe.nutrients_per_serving[2] != null ? chosenRecipe.nutrients_per_serving[2].per_serving : 0">
									</NutritionalTrafficLight>
								</div> -->
							</div>
							<div class="modal-footer">
								<button type="button" class="btn btn-nutri-red" data-dismiss="modal">Close</button>
							</div>
						</div>
					</div>
				</div>

			</div>

		</div>
		<!-- /Main Content -->
		<loading :active.sync="isLoading"></loading>
	</div>
</template>

<script>
	import API from "../../services/api.js";
	import AppHeader from '../../components/common/AppHeader.vue'
	import AppFooter from '../../components/common/AppFooter.vue'
	import WeightStatusWidget from '../../components/common/WeightStatusWidget.vue'
	import WeightProgressChart from '../../components/common/WeightProgressChart.vue'
	import WaterTracker from '../../components/common/WaterTracker.vue'
	import Datepicker from 'vuejs-datepicker';
	// Import component
	import Loading from 'vue-loading-overlay';
	// Import stylesheet
	import 'vue-loading-overlay/dist/vue-loading.css';
	import { Carousel, Slide } from 'vue-carousel';
	import NutritionalTrafficLight from '../../components/common/TrafficLights.vue';

	import { Datetime } from 'vue-datetime'
	// You need a specific loader for CSS files
	import 'vue-datetime/dist/vue-datetime.css'

	const api = new API();

	export default {
		data() {
			return {
				showWeightWidget: true,
				showWeightChart: false,
				date: this.$store.getters.globalDate,
				food_data:null,
				nutrition_data:{},
				waterTrackerKey: "water_tracker_" + Math.random(0,100),
				isLoading: false,
				recipes: [],
				chosenRecipe: null,
			}
		},
		components: {
			AppHeader,
			AppFooter,
			WeightStatusWidget,
			WeightProgressChart,
			WaterTracker,
			Datepicker,
			Loading,
			Carousel,
			Slide,
			NutritionalTrafficLight,
			Datetime
		},
		methods:{
			refreshComponents(){
				this.waterTrackerKey = "water_tracker_" + Math.random(0,100);
			},
			getFoodsForToday() {
				this.isLoading = true;
				api.getFoodsByDate(this.date).then(async response => {
					if (response.data.success) {
						this.food_data = response.data.data;
						this.nutrition_data = {};
						// for(var m in this.food_data.meals){
						// 	if(this.food_data["nutrient_" + m].calories != null) {
						// 		this.nutrition_data[m.replace("_", " ").toUpperCase()] = this.food_data["nutrient_" + m].calories;
						// 	}
						// }

						//As Requested by him we will not show calories
						// this.nutrition_data['Calories'] = 0;
						this.nutrition_data['Fats'] = 0;
						this.nutrition_data['Carbs'] = 0;
						this.nutrition_data['Protein'] = 0;
						

						for(var m in this.food_data.meals){
							//As Requested by him we will not show calories
							// if(this.food_data["nutrient_" + m].calories != null) {
							// 	this.nutrition_data['Calories'] = this.nutrition_data['Calories'] + this.food_data["nutrient_" + m].calories;
							// }
							
							if(this.food_data["nutrient_" + m].carbohydrates_available != null) {
								this.nutrition_data['Carbs'] = this.nutrition_data['Carbs'] + this.food_data["nutrient_" + m].carbohydrates_available;
							}
							if(this.food_data["nutrient_" + m].protein != null) {
								this.nutrition_data['Protein'] = this.nutrition_data['Protein'] + this.food_data["nutrient_" + m].protein;
							}
							if(this.food_data["nutrient_" + m].total_fat != null) {
								this.nutrition_data['Fats'] = this.nutrition_data['Fats'] + this.food_data["nutrient_" + m].total_fat;
							}
						}
						this.food_loaded = true;
						this.mealsKey = "meals_key_" + Math.random(0,100);

						//As Requested by him we will not show calories
						// this.nutrition_data['Calories'] = this.nutrition_data['Calories'].toFixed(0);
						
						this.nutrition_data['Fats'] = this.nutrition_data['Fats'].toFixed(0);
						this.nutrition_data['Carbs'] = this.nutrition_data['Carbs'].toFixed(0);
						this.nutrition_data['Protein'] = this.nutrition_data['Protein'].toFixed(0);

						this.isLoading = false;
					}
				});
			},
		},		
		created: function () {
			this.date = new Date();
			this.$store.commit('updateGlobalDate', this.date);			
			api.getDashRecipes().then(async response => {
				if (response.data.success) {
					this.recipes  = response.data.data;
				}
			});
			this.getFoodsForToday();
		},
		mounted: function () {},
		watch: {
			'date': function () {
				this.refreshComponents();
				this.getFoodsForToday();
				this.$store.commit('updateGlobalDate', this.date);
			}
		}
	}
</script>


<style scoped>
.card-view{
	box-shadow: 6px 11px 25px 0px rgba(0,0,0,0.3) !important;
}

.description{
	padding-left:25px;
	padding-right:25px;
}

.slide-title{
	text-align: center;
	margin-top: 25px;
}

.top-panels{
	height: 450px;
}
.dashboardTitle{
	margin-left: 15px;
}

.datePicker{
	margin-left: 9px;
}


</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Dashboard.vue